export const events = [
    {
        name: 'call.processed',
        description: 'Call processed event',
    },
    {
        name: 'call.finished',
        description: 'A call has finished.',
    },
    {
        name: 'opportunity.created',
        description: 'A new opportunity was created.',
    },
    {
        name: 'opportunity.updated',
        description: 'An existing opportunity has been updated.',
    },
    {
        name: 'opportunity.removed',
        description: 'An opportunity was removed.',
    },
    {
        name: 'opportunity.won',
        description: 'An opportunity was won.',
    },
    {
        name: 'opportunity.lost',
        description: 'An opportunity was lost.',
    },
    {
        name: 'opportunity.stuck',
        description: 'An opportunity was stuck and did not progress.',
    },
    {
        name: 'opportunity.pipeline.changed',
        description: 'An opportunity pipeline has changed.',
    },
    {
        name: 'opportunity.stage.changed',
        description: 'An opportunity stage has changed.',
    },
    {
        name: 'reminder.due',
        description: 'A reminder is due.',
    },
    {
        name: 'sms.message.added',
        description: 'A new SMS message was added (sent/received) to a conversation.',
    },
    {
        name: 'thread.status.updated',
        description: 'A thread status was updated.',
    },
    {
        name: 'thread.ai_response_status.updated',
        description: 'AI responses were enabled or disabled in a conversation.',
    },
    {
        name: 'note.added',
        description: 'A note was added to a customer.',
    },
    {
        name: 'publication.created',
        description: 'A publication was created.',
    },
    {
        name: 'publication.updated',
        description: 'A publication was updated.',
    },
    {
        name: 'publication.removed',
        description: 'A publication was removed.',
    },
    {
        name: 'publication.approved',
        description: 'A publication was approved.',
    },
    {
        name: 'publication.rejected',
        description: 'A publication was rejected.',
    },
    {
        name: 'publication.stage.changed',
        description: 'A publication was moved to a different stage.',
    },
    {
        name: 'calendar.event.created',
        description: 'A calendar event was created.',
    },
    {
        name: 'calendar.event.updated',
        description: 'A calendar event was updated.',
    },
    {
        name: 'calendar.event.removed',
        description: 'A calendar event was removed.',
    },
    {
        name: 'calendar.event.rescheduled',
        description: 'A calendar event was rescheduled.',
    },
    {
        name: 'calendar.event.status.changed',
        description: 'A calendar event status was changed.',
    },
    {
        name: 'calendar.event.accepted',
        description: 'A calendar event was accepted.',
    },
    {
        name: 'calendar.event.rejected',
        description: 'A calendar event was rejected.',
    },
];
